import { render } from "./partner-footer.vue?vue&type=template&id=4f9c274e"
import script from "./partner-footer.vue?vue&type=script&lang=js"
export * from "./partner-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__